import { MedicationRequest, CdsCard, CdsService, CdsDebugInfo, MedicationAdministration } from '../../fhir'
import { ErrorMessage } from '../'

export enum ActionType {
  SetHookInstanceId = 'SetHookInstanceId',
  SetMedication = 'SetMedication',
  SetAdministrations = 'SetAdministrations',
  SetCards = 'SetCards',
  SetCdsServices = 'SetCdsServices',
  AddError = 'AddError',
  ResetErrors = 'ResetErrors',
  SetServerDebugInfo = 'SetServerDebugInfo',
  SetMedicationRequest = 'SetMedicationRequest',
  SetPrefetchLoaded = 'SetPrefetchLoaded',
  SetServicesLoaded = 'SetServicesLoaded',
  SetMedicationPopulated = 'SetMedicationPopulated'
}

export type Action =
  | { type: ActionType.SetHookInstanceId; payload: string }
  | { type: ActionType.SetMedication; payload: object }
  | { type: ActionType.SetAdministrations; payload: MedicationAdministration[] }
  | { type: ActionType.SetCards; payload: CdsCard[] }
  | { type: ActionType.SetCdsServices; payload: CdsService[] }
  | { type: ActionType.AddError; payload: ErrorMessage[] }
  | { type: ActionType.ResetErrors; }
  | { type: ActionType.SetServerDebugInfo; payload: CdsDebugInfo[] }
  | { type: ActionType.SetMedicationRequest; payload: MedicationRequest }
  | { type: ActionType.SetPrefetchLoaded; payload: boolean }
  | { type: ActionType.SetServicesLoaded; payload: boolean }
  | { type: ActionType.SetMedicationPopulated; payload: boolean }

interface ISetHookInstanceId {
  type: ActionType.SetHookInstanceId
  payload: any
}

interface ISetMedication {
  type: ActionType.SetMedication
  payload: any
}

interface ISetAdministrations {
  type: ActionType.SetAdministrations
  payload: MedicationAdministration[]
}

interface ISetCards {
  type: ActionType.SetCards
  payload: CdsCard[]
}

interface ISetCdsServices {
  type: ActionType.SetCdsServices
  payload: CdsService[]
}

interface IAddError {
  type: ActionType.AddError
  payload: ErrorMessage[]
}

interface IResetErrors {
  type: ActionType.ResetErrors
}

interface ISetServerDebugInfo {
  type: ActionType.SetServerDebugInfo
  payload: CdsDebugInfo[]
}

interface ISetMedicationRequest {
  type: ActionType.SetMedicationRequest
  payload: MedicationRequest
}

interface ISetPrefetchLoaded {
  type: ActionType.SetPrefetchLoaded
  payload: boolean
}

interface ISetServicesLoaded {
  type: ActionType.SetServicesLoaded
  payload: boolean
}

interface ISetMedicationPopulated {
  type: ActionType.SetMedicationPopulated
  payload: boolean
}

const SetHookInstanceId = (value: string): ISetHookInstanceId => ({
  type: ActionType.SetHookInstanceId,
  payload: value
})

const SetMedication = (value: any): ISetMedication => ({
  type: ActionType.SetMedication,
  payload: value
})

const SetAdministrations = (value: MedicationAdministration[]): ISetAdministrations => ({
  type: ActionType.SetAdministrations,
  payload: value
})

const SetCards = (value: any): ISetCards => ({
  type: ActionType.SetCards,
  payload: value
})

const SetCdsServices = (value: any): ISetCdsServices => ({
  type: ActionType.SetCdsServices,
  payload: value
})

const AddError = (value: any): IAddError => ({
  type: ActionType.AddError,
  payload: value
})

const ResetErrors = (): IResetErrors => ({
  type: ActionType.ResetErrors
})

const SetServerDebugInfo = (value: CdsDebugInfo[]): ISetServerDebugInfo => ({
  type: ActionType.SetServerDebugInfo,
  payload: value
})

const SetMedicationRequest = (value: MedicationRequest): ISetMedicationRequest => ({
  type: ActionType.SetMedicationRequest,
  payload: value
})

const SetPrefetchLoaded = (value: boolean): ISetPrefetchLoaded => ({
  type: ActionType.SetPrefetchLoaded,
  payload: value
})

const SetServicesLoaded = (value: boolean): ISetServicesLoaded => ({
  type: ActionType.SetServicesLoaded,
  payload: value
})

const SetMedicationPopulated = (value: boolean): ISetMedicationPopulated => ({
  type: ActionType.SetMedicationPopulated,
  payload: value
})

export const Actions = {
  SetHookInstanceId,
  SetMedication,
  SetAdministrations,
  SetCards,
  SetCdsServices,
  AddError,
  ResetErrors,
  SetServerDebugInfo,
  SetMedicationRequest,
  SetPrefetchLoaded,
  SetServicesLoaded,
  SetMedicationPopulated
}
